import moment from "moment";

const dailySlotDuration = 2

export const CalculateTotal = (data, claims) => {
    const currentDate = moment(); // Get the current date
    let total = 0; // Variable to accumulate total hours
 
    const result = data?.map((item) => {
        // Calculate total hours from theory and practical hours
        const hours = Number(item?.cources?.theory) + Number(item?.cources?.practical);

        // Total days required (based on the total hours and daily slot duration)
        const totalDays = Math.ceil(hours / dailySlotDuration);

        let slots = [];
        try {
            slots = JSON.parse(item?.slots) || []; // Parse the stringified JSON for slots
        } catch (error) {
            console.error("Error parsing slots:", error);
            return; // In case of error, skip the current item
        }
        // Completed days: Difference between booking date and current date
        let completedDays = slots?.filter((item) => Number(item?.status) === 0).length;
        const slotIds = slots?.filter((slot) => Number(slot?.status) === 0).map((slot) => slot?.id);

        const CompletionPercentage = (completedDays / totalDays) * 100;

        if (claims && claims.length > 0) {
            // Iterate over lessonDetails in claims
            claims?.forEach((claim) => {
                const Lesson = JSON.parse(claim?.lessondetails);
                Lesson && Lesson.map((lessonDetail) => {
                    // Check if lessonId matches the item.id in the data array
                    if (lessonDetail.id === item.id) {
                        completedDays -= lessonDetail.completedDays; // Subtract the claimed completed days
                    }
                });
            });
        }

        const dailyRate = Number(item?.cources?.price) / totalDays;
        const amount = completedDays > 0 ? dailyRate * completedDays : 0;


        let remainingDays = slots.filter((item) => Number(item?.status) === 1).length;;

        // Only include items where completedDays > 0
        
        if (completedDays > 0) {
            // Add to the total sums
            total += amount;

            return {
                id: item?.id,
                lessonId: item?.id,
                customerName: item?.user?.name,
                courseName: item?.cources?.title,
                bookingDate: item?.bookingdate,
                bookingTime: item?.bookingtime,
                slotTime: item?.bookingtime,
                slotID: slotIds,
                amount: amount,
                customerId: item?.user?.id || "",
                courseCompleted: CompletionPercentage,
                completedDays: completedDays >= 0 ? completedDays : 0,  // Ensure no negative completed days
                remainingDays: remainingDays >= 0 ? remainingDays : 0,  // Ensure no negative remaining days
            };
        }

        // Return null for completedDays <= 0
        return null;
    }).filter(item => item); // Filter out null values (items where completedDays <= 0)

    // Add the Total variable to the response
    return {
        result: result,
        Total: total,
    };
}



























// import moment from "moment";

// const dailySlotDuration = 2

// export const CalculateTotal = (data, claims) => {
//     const currentDate = moment(); // Get the current date
//     let total = 0; // Variable to accumulate total hours

//     console.log("tenp", data)

//     const result = data?.forEach((item) => {
//         // Calculate total hours from theory and practical hours
//         const hours = Number(item?.cources?.theory) + Number(item?.cources?.practical);

//         // Total days required (based on the total hours and daily slot duration)
//         const totalDays = Math.ceil(hours / dailySlotDuration);

//         let slots = [];
//         try {
//             slots = JSON.parse(item?.slots) || []; // Parse the stringified JSON for slots
//         } catch (error) {
//             console.error("Error parsing slots:", error);
//             return; // In case of error, skip the current item
//         }
//         // Completed days: Difference between booking date and current date
//         let completedDays = slots?.filter((item) => Number(item?.status) === 0).length;
//         const slotIds = slots?.filter((slot) => Number(slot?.status) === 0).map((slot) => slot?.id);

//         const CompletionPercentage = (completedDays / totalDays) * 100;

//         if (claims && claims.length > 0) {
//             // Iterate over lessonDetails in claims
//             claims?.forEach((claim) => {
//                 const Lesson = JSON.parse(claim?.lessondetails);
//                 Lesson && Lesson.map((lessonDetail) => {
//                     // Check if lessonId matches the item.id in the data array
//                     if (lessonDetail.id === item.id) {
//                         completedDays -= lessonDetail.completedDays; // Subtract the claimed completed days
//                     }
//                 });
//             });
//         }

//         const dailyRate = Number(item?.cources?.price) / totalDays;
//         const amount = completedDays > 0 ? dailyRate * completedDays : 0;


//         let remainingDays = slots.filter((item) => Number(item?.status) === 1).length;;

//         // Only include items where completedDays > 0
//         if (completedDays > 0) {
//             // Add to the total sums
//             total += amount;

//             const tempslots = slots?.filter((slot) => Number(slot?.status) === 0)?.map((slot) => {
//                 return {
//                     lessonId: item?.id,
//                     courseName: item?.cources?.title,
//                     bookingDate: item?.bookingdate,
//                     bookingTime: item?.bookingtime,
//                     slotDate: slot.date,
//                     slotID: slot.id,
//                     slotTime: item?.bookingtime,
//                     amount: amount,
//                     customerId: item?.user?.id || "",
//                     customerName: item?.user?.name || "",
//                     courseCompleted: CompletionPercentage,
//                     completedDays: completedDays >= 0 ? completedDays : 0,  // Ensure no negative completed days
//                     remainingDays: remainingDays >= 0 ? remainingDays : 0,  // Ensure no negative remaining days
//                 };
//             })

//             result = [...result, ...tempslots]

//         }

//     }) // Filter out null values (items where completedDays <= 0)

//     // .filter(item => item);
//     // Add the Total variable to the response
//     return {
//         result: result,
//         Total: total,
//     };
// }

